/**
 * Downloads content as a file
 */
export function downloadAsFile(content: string, filename: string): void {
    const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.style.display = 'none';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
}

/**
 * Downloads API key as JSON file with metadata
 */
export function downloadApiKeyFile(keyName: string, apiKey: string): void {
    const content = JSON.stringify(
        {
            name: keyName,
            key: apiKey,
            createdAt: new Date().toISOString(),
            warning: 'Keep this file secure. Delete after storing the key safely.',
        },
        null,
        2
    );

    const safeFilename = keyName.toLowerCase().replace(/[^a-z0-9]/g, '-');
    downloadAsFile(content, `${safeFilename}-api-key.json`);
}
